import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import { SidebarService } from '../../../core/services';
import {MediaMatcher} from '@angular/cdk/layout';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() login = true;
  mobileQuery: MediaQueryList;
  readonly mobileQueryListener: () => void;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private sidebarService: SidebarService) {

    this.mobileQuery = media.matchMedia('(max-width: 1280px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
  }

  ngOnInit() {
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }
}
